import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Card } from '@mui/material';
import { colors } from '../../theme';
import {
    Container,
    Row,
    Col,
} from 'react-bootstrap';
import {
    AddAgentTitle,
    AddAgentInputTitle,
    InputText,
    OrganizationItem
} from './styles';
import './index.css';
const CreateAgentDialog = ({
    active,
    handleClose,
    title,
    selectedAgentForFilter,
    setSelectedAgentForFilter,
    selectedConstructorForFilter,
    setSelectedConstructorForFilter,
    selectedCampaignForFilter,
    setSelectedCampaignForFilter,
    selectedExecutorForFilter,
    setSelectedExecutorForFilter,
    showAgentDialog,
    setShowAgentDialog,
    localListAgent,
    applyFilter,
    handleFilterAgent,
    localListCampaign,
    showCampaignDialog,
    setShowCampaignDialog,
    handleFilterCampaign,
    showselectConstructor,
    setShowselectConstructor,
    handleFilterConstructor,
    localListConstructor,
    handleFilterExecutor,
    showSelecteExecutor,
    setShowSelecteExecutor,
    localExecutorList,
    clearFilter
   
   
 
  
               
    
}) => {
 
    return (
        <>
            <Dialog

                open={active}
            >
                <DialogTitle style={{
                    backgroundColor: colors.inputBackgroundColor,
                    color: colors.white
                }}>
                    <AddAgentTitle>{title}</AddAgentTitle></DialogTitle>
                <DialogContent style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Container fluid>
                        <Row style={{ width: "30vw", marginTop: 16 }} >
                            <Col>
                                <AddAgentInputTitle>Agent</AddAgentInputTitle>
                            </Col>
                            <Col>
                                <InputText
                                    placeholder='Select Agent'
                                    className='agentSearchClass'
                                    value={selectedAgentForFilter?.name ? selectedAgentForFilter?.name :"None"}
                                    onClick={(e)=>{
                                        setShowAgentDialog(!showAgentDialog);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ width: "30vw", marginTop: 16 }} >
                            <Col>
                                <AddAgentInputTitle>Constructor</AddAgentInputTitle>
                            </Col>
                            <Col>
                                <InputText
                                    placeholder='Select Constructor'
                                    className='agentSearchClass'
                                    value={selectedConstructorForFilter?.name ? selectedConstructorForFilter?.name : "None"}
                                    onClick={(e)=>{
                                        setShowselectConstructor(!showselectConstructor);
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row style={{ width: "30vw", marginTop: 16 }} >
                            <Col>
                                <AddAgentInputTitle>Executor</AddAgentInputTitle>
                            </Col>
                            <Col>
                                <InputText
                                    placeholder='Select Executor'
                                    className='agentSearchClass'
                                    value={selectedExecutorForFilter?.name ? selectedExecutorForFilter?.name : "None"}
                                    onClick={(e)=>{
                                        setShowSelecteExecutor(!showSelecteExecutor);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ width: "30vw", marginTop: 16 }} >
                            <Col>
                                <AddAgentInputTitle>Campaign</AddAgentInputTitle>
                            </Col>
                            <Col>
                                <InputText
                                    placeholder='Select Campaign'
                                    className='agentSearchClass'
                                    value={selectedCampaignForFilter?.name ? selectedCampaignForFilter?.name : "None"}
                                    onClick={(e)=>{
                                        setShowCampaignDialog(!showCampaignDialog);
                                    }}
                                />
                            </Col>
                        </Row>
                        
                    </Container>
                </DialogContent>
                <DialogActions style={{ backgroundColor: colors.inputBackgroundColor,paddingBottom:16 }}>
                <Button onClick={()=>{
                   // handleCreateInCampaign()
                   handleClose(false);
                   clearFilter();
                }}  
                style={{
                    color:colors.FailedTheme,
                    fontWeight:"bolder"
                }}
                
                > {"Clear"}</Button>
                <Button onClick={()=>{
                    applyFilter()
                    handleClose();
                }}  
                style={{
                    color:colors.white,
                    fontWeight:"bolder"
                }}
                
                > {"Filter"}</Button>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog

                open={showAgentDialog}

            >
                <DialogTitle style={{
                    backgroundColor: colors.inputBackgroundColor,
                    color: colors.white
                }}>
                    <AddAgentTitle>Choose Agent</AddAgentTitle></DialogTitle>
                <DialogContent style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Container fluid>
                        <Row style={{ width: "30vw", marginTop: 16 }} >

                            <Col>
                                <center>
                                    <InputText
                                        placeholder='Search agent'
                                        className='agentSearchClass'
                                        style={{ textAlign: "center", width: 200 }}
                                        onChange={(e) => {
                                            handleFilterAgent(e.target.value);
                                        }}


                                    />
                                </center>

                            </Col>
                        </Row>

                        <ul style={{ width: "30vw", marginTop: 16, height: "40vh", listStyleType: "none", padding: 0 }} >

                            {localListAgent.length == 0 &&

                                <OrganizationItem>Agent not found</OrganizationItem>
                            }
                            {localListAgent.map((data, i) => {
                                return (
                                    <Card
                                        onClick={() => {
                                            setShowAgentDialog(!showAgentDialog);
                                            setSelectedAgentForFilter(data);

                                        }}
                                        style={{
                                            backgroundColor: colors.splitLineColor,
                                            marginTop: 20,
                                            padding: 10
                                        }}
                                    >
                                        <OrganizationItem>{data.name}</OrganizationItem>
                                        <OrganizationItem style={{ color: colors.activeBlue, fontWeight: "600", fontSize: 13 }}>ID : {data.id}</OrganizationItem>
                                    </Card>
                                );
                            })}


                        </ul>

                    </Container>

                </DialogContent>
                <DialogActions style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Button onClick={() => {
                        setShowAgentDialog(!showAgentDialog)
                    }}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog

open={showCampaignDialog}

>
<DialogTitle style={{
    backgroundColor: colors.inputBackgroundColor,
    color: colors.white
}}>
    <AddAgentTitle>Choose Campaign</AddAgentTitle></DialogTitle>
<DialogContent style={{ backgroundColor: colors.inputBackgroundColor }}>
    <Container fluid>
        <Row style={{ width: "30vw", marginTop: 16 }} >

            <Col>
                <center>
                    <InputText
                        placeholder='Search agent'
                        className='agentSearchClass'
                        style={{ textAlign: "center", width: 200 }}
                        onChange={(e) => {
                            handleFilterCampaign(e.target.value);
                        }}


                    />
                </center>

            </Col>
        </Row>

        <ul style={{ width: "30vw", marginTop: 16, height: "40vh", listStyleType: "none", padding: 0 }} >

            {localListCampaign.length == 0 &&

                <OrganizationItem>Campaign not found</OrganizationItem>
            }
            {localListCampaign.map((data, i) => {
                return (
                    <Card
                        onClick={() => {
                            setShowCampaignDialog(!showCampaignDialog)
                            setSelectedCampaignForFilter(data);

                        }}
                        style={{
                            backgroundColor: colors.splitLineColor,
                            marginTop: 20,
                            padding: 10
                        }}
                    >
                        <OrganizationItem>{data.name}</OrganizationItem>
                        <OrganizationItem style={{ color: colors.activeBlue, fontWeight: "600", fontSize: 13 }}>ID : {data.id}</OrganizationItem>
                    </Card>
                );
            })}


        </ul>

    </Container>

</DialogContent>
<DialogActions style={{ backgroundColor: colors.inputBackgroundColor }}>
    <Button onClick={() => {
        setShowCampaignDialog(!showCampaignDialog)
    }}>Close</Button>
</DialogActions>
</Dialog>

<Dialog
                open={showselectConstructor}
            >
                <DialogTitle style={{
                    backgroundColor: colors.inputBackgroundColor,
                    color: colors.white
                }}>
                    <AddAgentTitle>Choose Construction</AddAgentTitle></DialogTitle>
                <DialogContent style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Container fluid>
                        <Row style={{ width: "30vw", marginTop: 16 }} >

                            <Col>
                                <center>
                                    <InputText
                                        placeholder='Search Construction'
                                        className='agentSearchClass'
                                        style={{ textAlign: "center", width: 200 }}
                                        onChange={(e) => {
                                            handleFilterConstructor(e.target.value);
                                        }}


                                    />
                                </center>

                            </Col>
                        </Row>

                        <ul style={{ width: "30vw", marginTop: 16, height: "40vh", listStyleType: "none", padding: 0 }} >

                            {localListConstructor.length == 0 &&

                                <OrganizationItem>Construction not found</OrganizationItem>
                            }
                            {localListConstructor.map((data, i) => {
                                return (
                                    <Card
                                        onClick={() => {
                                            setSelectedConstructorForFilter(data);
                                            setShowselectConstructor(!showselectConstructor);

                                        }}
                                        style={{
                                            backgroundColor: colors.splitLineColor,
                                            marginTop: 20,
                                            padding: 10
                                        }}
                                    >
                                        <OrganizationItem>{data.name}</OrganizationItem>
                                        <OrganizationItem style={{ color: colors.activeBlue, fontWeight: "600", fontSize: 13 }}>ID : {data.id}</OrganizationItem>
                                    </Card>
                                );
                            })}


                        </ul>

                    </Container>

                </DialogContent>
                <DialogActions style={{ backgroundColor: colors.inputBackgroundColor }}>
                    <Button onClick={() => {
                        setShowselectConstructor(!showselectConstructor);
                    }}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog

open={showSelecteExecutor}

>
<DialogTitle style={{
    backgroundColor: colors.inputBackgroundColor,
    color: colors.white
}}>
    <AddAgentTitle>Choose Exectors</AddAgentTitle></DialogTitle>
<DialogContent style={{ backgroundColor: colors.inputBackgroundColor }}>
    <Container fluid>
        <Row style={{ width: "30vw", marginTop: 16 }} >

            <Col>
                <center>
                    <InputText
                        placeholder='Search Executor'
                        className='agentSearchClass'
                        style={{ textAlign: "center", width: 200 }}
                        onChange={(e) => {
                            handleFilterExecutor(e.target.value);
                        }}


                    />
                </center>

            </Col>
        </Row>

        <ul style={{ width: "30vw", marginTop: 16, height: "40vh", listStyleType: "none", padding: 0 }} >

            {localExecutorList.length == 0 &&

                <OrganizationItem>Executor not found</OrganizationItem>
            }
            {localExecutorList.map((data, i) => {
                return (
                    <Card
                        onClick={() => {
                            setSelectedExecutorForFilter(data);
                            setShowSelecteExecutor(!showSelecteExecutor);
                        }}
                        style={{
                            backgroundColor: colors.splitLineColor,
                            marginTop: 20,
                            padding: 10
                        }}
                    >
                         <OrganizationItem>{data.name}</OrganizationItem>
                        <OrganizationItem style={{ color: colors.activeBlue, fontWeight: "600", fontSize: 13 }}>ID : {data.id}</OrganizationItem>
                    </Card>
                );
            })}


        </ul>

    </Container>

</DialogContent>
<DialogActions style={{ backgroundColor: colors.inputBackgroundColor }}>

    <Button onClick={() => {

        setShowSelecteExecutor(!showSelecteExecutor);
    }}>Close</Button>
</DialogActions>
</Dialog>
        </>
    );
};

export default CreateAgentDialog;